var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_c('i',{staticClass:"far fa-eye fa-fw"}),_vm._v(" "+_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))]),_c('b-card',{attrs:{"no-body":""}},[_c('b-list-group',{attrs:{"flush":""}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }